/**
 * Canonical outbound URL for The Real Startup Book (2nd Edition).
 *
 * Centralized here so the footer link, post-game CTA, and any future
 * placements resolve the same destination. The sibling games-and-tools
 * follow-ups (experimentcalculator, startup-poker, food-truck — filed as
 * separate per-repo issues) should mirror this pattern.
 */
export const RSB_URL = 'https://kromatic.com/download/the-real-startup-book?utm_campaign=rsb-launch-2026';
